import React from 'react'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {LeftRowFlexContainer, LeftTopRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {InfoOutlined} from '@mui/icons-material'
import {formatDateTimeWithoutSeconds} from '../../../../../formatters/formatDate'
import {ROLE_FOR_ADMINISTRATOR} from '../../../../../CodeMaster'

interface Props {
    comment: string
    roleId: string
    familyName: string
    firstName: string
    registerDatetime: string
}

export const NatAdminApplicationCommentToAssocDirector: React.FC<Props> = props => {
    const {comment, roleId, familyName, firstName, registerDatetime} = props

    return (
        <WideWhiteArea>
            <LeftRowFlexContainer>
                <InfoOutlinedIcon/><Box fontWeight={FontWeights.Bold}>承認・却下前にご確認ください。</Box>
            </LeftRowFlexContainer>
            <SmallText color={Colors.AccentDark} mt={'10px'}>理事長への連絡事項</SmallText>
            {comment}
            <Box mt={'16px'}>
                <LeftTopRowFlexContainer>
                    <SmallText color={Colors.AccentDark} flexShrink={0}>
                        {formatDateTimeWithoutSeconds(registerDatetime)}
                    </SmallText>
                    <SmallText ml={'8px'}>
                        {ROLE_FOR_ADMINISTRATOR.codeToEnumConstants(roleId).label} {familyName} {firstName}
                    </SmallText>
                </LeftTopRowFlexContainer>
            </Box>
        </WideWhiteArea>
    )
}


const InfoOutlinedIcon = withStyles({
    root: {
        color: `${Colors.AdminPrimary}`,
        width: '24px',
        height: '24px',
        marginRight: '4px',
    },
})(InfoOutlined)

const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  padding: 16px;
  box-sizing: border-box;
  box-shadow: 0px 2px 2px 0px #70707066;
  border-radius: 4px;
  line-height: 21px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`

const SmallText = styled(Box)`
  font-size: 12px;
  line-height: 18px;
`